import { useState, useEffect } from "react";
import { useCombobox } from "downshift";

const DropdownInput = ({
  id,
  name,
  register,
  errors,
  optional,
  options,
  params,
  label,
  onChange,
  onSelect,
  defaultValue,
  setValue,
  clearErrors,
  ...rest
}) => {
  const [items, setItems] = useState([]);

  const {
    isOpen,
    getLabelProps,
    getMenuProps,
    getInputProps,
    getComboboxProps,
    getItemProps,
    selectedItem,
    setInputValue,
  } = useCombobox({
    onInputValueChange({ inputValue }) {
      const new_params = { ...params };
      new_params["query"] = inputValue;
      onChange(new_params);
      handleChange(inputValue);
    },
    onSelectedItemChange({ selectedItem }) {
      onSelect(selectedItem);
      handleChange(selectedItem.name);
    },
    items,
    itemToString(item) {
      return item ? item.name : "";
    },
  });

  const handleChange = (value) => {
    setValue(name, value);
    clearErrors(name);
  };

  useEffect(() => {
    setItems(options);
  }, [options]);

  useEffect(() => {
    setInputValue(defaultValue);
  }, [defaultValue, setInputValue]);

  return (
    <div>
      <div className="w-full">
        <label htmlFor={id} className="form-label" {...getLabelProps()}>
          {label}
          {optional && (
            <span className="text-xs ml-2 text-gray-300">Optional</span>
          )}
        </label>
        <div className="flex bg-white gap-0.5" {...getComboboxProps()}>
          <input
            id={id}
            name={name}
            className={`form-control h-9 p-3 form-reset-focus-visible border ${
              errors && errors[name] && "form-invalid"
            }`}
            {...rest}
            {...register}
            {...getInputProps()}
          />
        </div>
        {errors && errors[name] && (
          <div className="pt-2">
            <span className="text-sm text-red-400">{errors[name].message}</span>
          </div>
        )}
      </div>
      <ul
        {...getMenuProps()}
        className="absolute p-0 w-72 bg-white shadow-md z-10 max-h-56 overflow-y-scroll"
      >
        {isOpen &&
          items.map((item, index) => (
            <li
              className={`py-2 px-3 shadow-sm flex cursor-pointer text-sm flex-col hover:text-white hover:bg-blue-400 ${
                selectedItem === item
                  ? "bg-blue-400 text-white"
                  : "text-gray-500"
              }`}
              key={`${item.id}${index}`}
              {...getItemProps({ item, index })}
            >
              <span className="font-medium">{item.name}</span>
              {item.description && (
                <span className="text-xs">{item.description}</span>
              )}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default DropdownInput;
